import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import {
  LeadBreakdownActions,
  LeadBreakdownCloseAction,
  LeadBreakdownCloseButton,
  LeadBreakdownContent,
  LeadBreakdownEmpty,
  LeadBreakdownIntro,
  LeadBreakdownTitle,
  LeadTable,
  LeadTableWrap,
  LeadTypeGrid,
  LeadTypeLabel,
  LeadTypeStat,
  LeadTypeValue,
  StyledLeadBreakdownDialog,
} from './AdminLeadBreakdownModal.styled';

const AdminLeadBreakdownModal = ({ open, onClose, leadBreakdown }) => {
  const rows = leadBreakdown?.byBusiness ?? [];

  return (
    <StyledLeadBreakdownDialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="admin-lead-breakdown-title"
    >
      <LeadBreakdownTitle id="admin-lead-breakdown-title">
        <span className="lead-breakdown-icon-wrap" aria-hidden>
          <ContactMailOutlinedIcon className="lead-breakdown-icon" />
        </span>
        <span>Lead breakdown</span>
        <LeadBreakdownCloseButton aria-label="Close" onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </LeadBreakdownCloseButton>
      </LeadBreakdownTitle>

      <LeadBreakdownContent>
        <LeadBreakdownIntro variant="body2">
          All-time totals for each business. Service inquiries are requests sent
          through NKY Connect. Phone and email clicks are storefront contact links.
        </LeadBreakdownIntro>
        {leadBreakdown ? (
          <>
            <LeadTypeGrid>
              <LeadTypeStat>
                <LeadTypeValue>{leadBreakdown.inquiryCount ?? 0}</LeadTypeValue>
                <LeadTypeLabel>Service inquiries</LeadTypeLabel>
              </LeadTypeStat>
              <LeadTypeStat>
                <LeadTypeValue>{leadBreakdown.phoneClicks ?? 0}</LeadTypeValue>
                <LeadTypeLabel>Phone clicks</LeadTypeLabel>
              </LeadTypeStat>
              <LeadTypeStat>
                <LeadTypeValue>{leadBreakdown.emailClicks ?? 0}</LeadTypeValue>
                <LeadTypeLabel>Email clicks</LeadTypeLabel>
              </LeadTypeStat>
            </LeadTypeGrid>
            {rows.length > 0 ? (
              <LeadTableWrap>
                <LeadTable>
                  <thead>
                    <tr>
                      <th>Business</th>
                      <th className="num">Inquiries</th>
                      <th className="num">Phone</th>
                      <th className="num">Email</th>
                      <th className="num">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row) => (
                      <tr key={row.businessId}>
                        <td>{row.businessName}</td>
                        <td className="num">{row.inquiryCount}</td>
                        <td className="num">{row.phoneClicks}</td>
                        <td className="num">{row.emailClicks}</td>
                        <td className="num">{row.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </LeadTable>
              </LeadTableWrap>
            ) : (
              <LeadBreakdownEmpty variant="body2">No leads yet.</LeadBreakdownEmpty>
            )}
          </>
        ) : (
          <LeadBreakdownEmpty variant="body2">
            Per-business detail is not available from the analytics API yet.
            The lead total on the metrics card is still the current all-time count.
          </LeadBreakdownEmpty>
        )}
      </LeadBreakdownContent>

      <LeadBreakdownActions>
        <LeadBreakdownCloseAction variant="outlined" onClick={onClose}>
          Close
        </LeadBreakdownCloseAction>
      </LeadBreakdownActions>
    </StyledLeadBreakdownDialog>
  );
};

export default AdminLeadBreakdownModal;
